<div class="row row-sm ">
    <div class="col-lg-12">
        <!-- <div class="card custom-card"> -->
        <div class="card-body">

            <div class="row">
                <div class="col-md-12">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                        <div *ngIf="submitButton" class="mb-0">
                            <h3 class="main-content-label mb-1"><b>Fees Template </b></h3>
                            <p class="text-muted card-sub-title mb-0"> New Fees Template Information</p>
                        </div>
                        <div *ngIf="editButton" class="mb-0">
                            <h3 class="main-content-label mb-1"><b>Fees Template</b></h3>
                            <p class="text-muted card-sub-title mb-0 ">Update Selected Fees Template
                                Information
                            </p>
                        </div>
                        <div *ngIf="deleteButton" class="mb-0">
                            <h3 class="main-content-label mb-1"><b>Fees Template</b></h3>
                            <p class="text-muted card-sub-title mb-0 ">Delete Selected Fees Template
                                Information
                            </p>
                        </div>
                    </div>
                </div>
                <hr class="mt-3">

                <div class="row row-sm mt-0 pt-0 add-form min">
                    <form autocomplete="off" class="p-0  mt-0 pt-0" novalidate [formGroup]="feeTempletForm">

                        <div class="card-body mt-0 pt-0">
                            <div class="row clearfix">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Template Code</mat-label>
                                                <input required [readonly]="isDelete || isUpdate "
                                                    onkeydown="return (event.keyCode!=13);" maxlength="5" class="color"
                                                    matInput formControlName="TemplateCode" placeholder="Template Code">
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['TemplateCode'].touched && feeTempletForm.controls['TemplateCode'].errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['TemplateCode'].touched && feeTempletForm.controls['TemplateCode'].errors?.pattern">
                                                    Invalid
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Template Name</mat-label>
                                                <input required [readonly]="isDelete || isUpdate "
                                                    onkeydown="return (event.keyCode!=13);" maxlength="50" class="color"
                                                    matInput formControlName="TemplateName" placeholder="Template Name">
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['TemplateName'].touched && feeTempletForm.controls['TemplateName'].errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['TemplateName'].touched && feeTempletForm.controls['TemplateName'].errors?.pattern">
                                                    Invalid
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Fee Type
                                            </mat-label>
                                            <mat-select required #select33 [disabled]="isDelete" class="colorblack"
                                                formControlName="FeeType">
                                                <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                                    [displayMember]="'CdDesc'" [array]="feeList"
                                                    (filteredReturn)="filteredfeeList =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredfeeList" [value]="item.CdCode" (onSelectionChange)="FType(item.CdCode)" (click)="FType(item.CdCode)">
                                                    {{item.CdDesc}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="feeTempletForm.controls['FeeType'].touched && feeTempletForm.controls['FeeType'].errors?.required">
                                                Mandatory
                                            </mat-error>
                                        </mat-form-field>

                                    </div>
                                </div>
                                <div *ngIf="FeeLvlShow" class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Fee Level
                                            </mat-label>
                                            <mat-select  #select331 [disabled]="isDelete" class="colorblack"
                                                formControlName="FeeLevel">
                                                <mat-select-filter *ngIf="select331.focused" [placeholder]="'Filter'"
                                                    [displayMember]="'CdDesc'" [array]="feeLvlList"
                                                    (filteredReturn)="filteredfeeLvlList =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredfeeLvlList" [value]="item.CdCode">
                                                    {{item.CdDesc}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="feeTempletForm.controls['FeeLevel'].touched && feeTempletForm.controls['FeeLevel'].errors?.required">
                                                Mandatory
                                            </mat-error>
                                        </mat-form-field>

                                    </div>
                                </div>
                                <div *ngIf="FeeExam" class="col-sm-3">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Exam
                                            </mat-label>
                                            <mat-select #select23 placeholder="Exam"
                                                formControlName="EmId">
                                                <mat-select-filter *ngIf="select23.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                    [array]="examList"
                                                    (filteredReturn)="filteredListExam =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredListExam"
                                                    [value]="item.EmId" (click)="arrEnable(item)">
                                                    {{ item | displayValue:'EmCode':'EmName' }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="feeTempletForm.controls['FeeLevel'].touched && feeTempletForm.controls['FeeLevel'].errors?.required">
                                                Mandatory
                                            </mat-error>
                                        </mat-form-field>

                                    </div>
                                </div>
                                <div class="col-sm-3" [hidden]="!StuType">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Student Type
                                                </mat-label>
                                                <mat-select multiple required #select333 [disabled]="isDelete || FTdisable" class="colorblack"
                                                    formControlName="StudentType">
                                                    <mat-select-filter *ngIf="select333.focused"
                                                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                        [array]="sTypeList"
                                                        (filteredReturn)="filteredsTypeList =$event"></mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredsTypeList"
                                                        [value]="item.CdCode"  (click)="changeCurreancy(item.CdCode)">
                                                        {{item.CdDesc}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['StudentType'].touched && feeTempletForm.controls['StudentType'].errors?.required">
                                                   Mandatory
                                                </mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3" [hidden]="!StuStatus">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Student Status
                                                </mat-label>
                                                <mat-select multiple required #select34 [disabled]="isDelete || FTdisable" class="colorblack"
                                                    formControlName="StudentStatus">
                                                    <mat-select-filter *ngIf="select34.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'CdDesc'" [array]="stuStatusList"
                                                        (filteredReturn)="filteredstuStatusList =$event"></mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredstuStatusList"
                                                        [value]="item.CdCode">
                                                        {{item.CdDesc}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['StudentStatus'].touched && feeTempletForm.controls['StudentStatus'].errors?.required">
                                                    Mandatory
                                                </mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="AdmMode" class="col-sm-3">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Addmission Mode
                                                </mat-label>
                                                <mat-select required #select35 [disabled]="isDelete || FTdisable" class="colorblack"
                                                    formControlName="AdmissionMode">
                                                    <mat-select-filter *ngIf="select35.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'CdDesc'" [array]="AdModeList"
                                                        (filteredReturn)="filteredAdModeList =$event"></mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredAdModeList"
                                                        [value]="item.CdCode">
                                                        {{item.CdDesc}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['AdmissionMode'].touched && feeTempletForm.controls['AdmissionMode'].errors?.required">
                                                   Mandatory
                                                </mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3" [hidden]="!ScRes">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Social Reservation
                                                </mat-label>

                                                <mat-select multiple required #select385 [disabled]="isDelete || FTdisable" class="colorblack"
                                                    formControlName="SocialReservation">
                                                    <mat-select-filter *ngIf="select385.focused"
                                                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                        [array]="SRList"
                                                        (filteredReturn)="filteredSR =$event"></mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredSR" [value]="item.CdCode">
                                                        {{item.CdDesc}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['SocialReservation'].touched && feeTempletForm.controls['SocialReservation'].errors?.required">
                                                   Mandatory
                                                </mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3" [hidden]="!Handi">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Is Handicap?
                                                </mat-label>
                                                <mat-select required [disabled]="isDelete || FTdisable" formControlName="IsHandicap">
                                                    <mat-option [value]=true>Yes</mat-option>
                                                    <mat-option [value]=false>No</mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['IsHandicap'].touched && feeTempletForm.controls['IsHandicap'].errors?.required">
                                                   Mandatory
                                                </mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3" [hidden]="!ScQuota">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Schema Quota
                                                </mat-label>
                                                <mat-select multiple required [disabled]="isDelete || FTdisable"
                                                    formControlName="SchemaQuota"  (selectionChange)="onSchemaQuotaChange($event.value)">
                                                    <mat-option value="a" [disabled]="lockSchemaOptions">management quota</mat-option>
                                                    <mat-option value="b" [disabled]="lockSchemaOptions">Addmission</mat-option>
                                                    <mat-option value="OS">old student</mat-option>
                                                    <mat-option value="NA" [disabled]="lockSchemaOptions">NA</mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['SchemaQuota'].touched && feeTempletForm.controls['SchemaQuota'].errors?.required">
                                                   Mandatory
                                                </mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3" [hidden]="!Cast">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Cast
                                                </mat-label>
                                                <mat-select multiple required #select11 [disabled]="isDelete || FTdisable" class="colorblack"
                                                    formControlName="constitutional">
                                                    <mat-select-filter *ngIf="select11.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'CdDesc'" [array]="castList"
                                                        (filteredReturn)="filteredcastList =$event"></mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredcastList"
                                                         [value]="item.CdCode">
                                                        {{item.CdDesc}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['constitutional'].touched && feeTempletForm.controls['constitutional'].errors?.required">
                                                   Mandatory
                                                </mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <!--
                                <div class="col-sm-3" *ngIf="SubCast">
                                    <div class="form-group">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Sub Cast
                                            </mat-label>
                                            <mat-select #select33 [disabled]="isDelete || FTdisable" class="colorblack"
                                                formControlName="Caste">
                                                <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                                    [displayMember]="'CasteName'" [array]="categoryList"
                                                    (filteredReturn)="filteredCategoryList =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredCategoryList"
                                                    [value]="item.CasteCode">
                                                    {{item.CasteName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="feeTempletForm.controls['Caste'].touched && feeTempletForm.controls['Caste'].errors?.required">
                                               Mandatory
                                            </mat-error>
                                        </mat-form-field>

                                    </div>
                                </div>
                                 -->
                                

                                <div class="col-sm-3" [hidden]="!Curr">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Currency
                                                </mat-label>

                                                <mat-select required #select382 [disabled]="isDelete" class="colorblack"
                                                    formControlName="Currency">
                                                    <mat-select-filter *ngIf="select382.focused"
                                                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                        [array]="CurrencyList"
                                                        (filteredReturn)="filteredCurrencyList =$event"></mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredCurrencyList" [value]="item.CdCode">
                                                        {{item.CdDesc}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="feeTempletForm.controls['Currency'].touched && feeTempletForm.controls['Currency'].errors?.required">
                                                   Mandatory
                                                </mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div *ngIf="Table" class="table-responsive min mt-4 ">
                                        <div class="table-container1">
                                            <table class="table  table-bordered text-nowrap text-left fee-table">
                                                <thead>
                                                    <tr class="">
                                                        <th id="td111" class="f600">
                                                            Heads
                                                        </th>
                                                        <th id="td111" class="f600" *ngIf="showFeeType">
                                                            Fee Type
                                                        </th>
                                                        <th id="td111" class="f600" *ngIf="showFeeType">
                                                            From Date
                                                        </th>
                                                        <th id="td111" class="f600" *ngIf="showFeeType">
                                                            To Date
                                                        </th>
                                                        <th id="td111" class="f600">
                                                            College/University
                                                        </th>
                                                        <th id="td1" class="f600">
                                                            Purpose
                                                        </th>
                                                        <th id="td1" width="10%" class="f600">
                                                            Amount
                                                        </th>
                                                        <th class="f600 text-center action-col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="table_data" formArrayName="feeHeadArray">
                                                    <!-- examSemList -->
                                                    <tr *ngFor="let fee of getfeeHeadArrayControls(); let i = index; let last = last "
                                                        [formGroupName]="i">
                                                        <!--  -->
                                                        <td>
                                                            <mat-form-field appearance="outline" class="example-full-width">
                                                                <mat-label>Head</mat-label>
                                                                <mat-select required [disabled]="isDelete" #select55 class="color" formControlName="FeeHead">
                                                                  <mat-select-filter *ngIf="select55.focused"
                                                                                     [placeholder]="'Filter'"
                                                                                     [displayMember]="'Head'"
                                                                                     [array]="FeeHeadList"
                                                                                     (filteredReturn)="filteredHeadList = $event">
                                                                  </mat-select-filter>
                                                                  <mat-option *ngFor="let item of filteredHeadList;"
                                                                              [value]="item.HeadCode"
                                                                              [disabled]="isSelected(item.HeadCode)"
                                                                              (onSelectionChange)="getHead(item, i, $event)">
                                                                    {{item.HeadCode}} - {{item.Head}}
                                                                  </mat-option>
                                                                </mat-select>
                                                                <mat-error class="margin_tp"
                                                                           *ngIf="fee.controls.FeeHead.touched && fee.controls.FeeHead.errors?.required">
                                                                  Mandatory
                                                                </mat-error>
                                                              </mat-form-field>
                                                        </td>
                                                        <td *ngIf="showFeeType">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width" id="td1">
                                                                <mat-label>Fee Type</mat-label>
                                                                <mat-select
                                                                (selectionChange)="onFeeTypeChange($event.value, i)"
                                                                    formControlName="EmFeeType" #select39011 
                                                                    placeholder="FeeType" class="colorblack"
                                                                    [compareWith]="compareEmFeeType">
                                                                    <mat-select-filter *ngIf="select39011.focused"
                                                                        [placeholder]="'FeeType'"
                                                                        [displayMember]="'CdDesc'"
                                                                        [array]="ExamFeeTypeList"
                                                                        (filteredReturn)="filteredExamFeeTypeList =$event">
                                                                    </mat-select-filter>
                                                                    <!-- (click)="getdates()" -->
                                                                    <mat-option
                                                                        *ngFor="let item of filteredExamFeeTypeList"
                                                                        [disabled]="isSelectedCode(item.CdCode)"
                                                                        [value]="item.CdCode">
                                                                        {{item.CdDesc}}
                                                                    </mat-option>
                                                                </mat-select>
                                                                <!-- <mat-error class="margin_tp"
                                                                    *ngIf="fee.controls.EmFeeType.touched && fee.controls.EmFeeType.errors?.required">
                                                                    Mandatory
                                                                </mat-error> -->
                                                            </mat-form-field>
                                                        </td> 

                                                         <td *ngIf="showFeeType">
                                                            <mat-form-field appearance="outline" 
                                                            class="example-full-width">
                                                        <mat-label>Choose From Date</mat-label>
                                                            <input (click)="action(fee)" 
                                                            class="color" matInput
                                                            [matDatepicker]="picker" 
                                                            [matDatepickerFilter]="dateFilter"
                                                            [min]="sessionCutoffFrom" 
                                                            [max]="sessionCutoffTo" 
                                                            (dateChange)="datechange(i)"
                                                            placeholder="CutOff Date" 
                                                            formControlName="EmFeeFromDate">
                                                        <mat-datepicker-toggle 
                                                            matSuffix [for]="picker">
                                                        </mat-datepicker-toggle>
                                                        <mat-datepicker #picker></mat-datepicker>
                                                        <mat-error class="margin_tp mrgtp"
                                                            *ngIf="fee.controls.EmFeeFromDate.touched && fee.controls.EmFeeFromDate.errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                        <mat-error *ngIf="fee.controls.EmFeeFromDate.errors?.fromGreater">
                                                            From Date cannot be greater than To Date
                                                        </mat-error>

                                                        <mat-error *ngIf="fee.controls.EmFeeFromDate.errors?.overlap">
                                                            From Date must be after previous To Date
                                                        </mat-error>
                                                    </mat-form-field>
                                                </td>
                        
                                                <td *ngIf="showFeeType">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Choose To Date</mat-label>
                                                        <input (click)="action(fee)" 
                                                        class="color" matInput
                                                        [matDatepicker]="picker1"
                                                        [matDatepickerFilter]="dateFilter"
                                                        [min]="sessionCutoffFrom"
                                                        [max]="sessionCutoffTo"
                                                        (dateChange)="datechange1(i)"
                                                        placeholder="CutOff Date" 
                                                        formControlName="EmFeeToDate">
                                                    <mat-datepicker-toggle 
                                                    matSuffix [for]="picker1">
                                                    </mat-datepicker-toggle>
                                                    <mat-datepicker #picker1 ></mat-datepicker>
                                                    <mat-error class="margin_tp mrgtp"
                                                        *ngIf="fee.controls.EmFeeToDate.touched && fee.controls.EmFeeToDate.errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                    <mat-error *ngIf="fee.controls.EmFeeToDate.errors?.dateError">
                                                        To Date must be greater than From Date
                                                    </mat-error>
                                                </mat-form-field>
                                                        </td>
                                                        <td>
                                                            <input class="form-control input-sm"
                                                                formControlName="ClgUni" readonly>
                                                        </td>
                                                        <td>
                                                            <input class="form-control input-sm"
                                                                formControlName="Purpose" readonly>
                                                        </td>
                                                        <td>
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>Fee Amount</mat-label>
                                                                <input required matInput
                                                                    onkeydown="return (event.keyCode!=13);"
                                                                    class="color" formControlName="FeeAmount"
                                                                    [readonly]="isDelete" maxlength="8" id="addone"
                                                                    (input)="onInputChange($event,i)">
                                                                <mat-error class="red" *ngIf=" errorcheckP(fee)">
                                                                   Invalid
                                                                </mat-error>
                                                                <!-- <mat-error class="red"
                                                        *ngIf=" errorcheckR(fee)">
                                                        This Field Is Mandatory
                                                    </mat-error> -->
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="fee.controls.FeeAmount.touched && fee.controls.FeeAmount.errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </td>
                                                        <td class="text-center">
                                                            <a *ngIf="last" class="btn-floating" title="AddNew">
                                                                <i class="fa fa-plus" (click)="addNewRow2(i,fee);"></i>
                                                            </a>
                                                            <a class="btn-floating" title="Remove">
                                                                <i class="fa fa-minus" (click)="deleteRow(i)"></i></a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                            <div *ngIf="showDateInfoMsg" class="date-info-msg">
                                                {{ dateInfoMsg }}
                                            </div>

                                    </div>
                                </div>


                                <hr>
                                <div class="col-sm-12">

                                    <label> <span class="Text">Total Amount :</span><span
                                            class="currency-symbol">&#8377;</span>{{totalAmount}} </label>

                                </div>

                                <hr>
                                <div class="row col-sm-12">
                                    <div class="col-sm-12 prpl">
                                        <button type="button" *ngIf="deleteButton && feeDelete"
                                            class="btn btn-primary btn-icon-text floatright mt-1"
                                            (click)="DeletetheRecord()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/trash.gif"
                                                    style="margin-right: 5px;">
                                                Delete
                                            </span>
                                        </button>
                                        <button type="button" *ngIf="editButton && feeUpdate" [disabled]="resPending"
                                            class="btn btn-primary btn-icon-text floatright mt-1" (click)="update()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/edit1.gif"
                                                    style="margin-right: 5px;">
                                                Update
                                            </span>
                                        </button>
                                        <button type="button" *ngIf="submitButton && feeCreate" [disabled]="resPending"
                                            class="btn btn-primary btn-icon-text floatright mt-1" (click)="save()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/save.gif"
                                                    style="margin-right: 5px;">
                                                Save
                                            </span>
                                        </button>
                                        <button type="button" [mat-dialog-close]="true"
                                            class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/turn-left.gif"
                                                    style="margin-right: 7px;">
                                                Back
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>